import { WSTableCell } from "@wingspanhq/fe-component-library";
import { WorkLog } from "@wingspanhq/wingspan-api-sdk";
import { queriesPayables } from "@query";
import { getWorkLogPayerStatusCellProps } from "../utils/getWorkLogPayerStatusCellProps";

type Props = {
  workLog: WorkLog;
};

// Renders the payer work-log status cell, fetching the work log's payable at the
// point of use. Each cell owns its own `getPayable` query, so it caches per
// payable id and refreshes on cancel/reopen via the registry's auto-invalidation
// — no shared pre-fetched map to go stale.
export const WorkLogPayerStatusCell: React.FC<Props> = props => {
  // TODO(v3): `invoiceId` renamed to `convertedResourceId` on v3 WorkLog.
  const payableId = props.workLog.convertedResourceId;

  const queryPayable = queriesPayables.getPayable.useQuery(
    { payableId: payableId as string },
    { enabled: !!payableId, retry: false }
  );

  const cellProps = getWorkLogPayerStatusCellProps({
    workLog: props.workLog,
    payable: queryPayable.data
  });

  return <WSTableCell {...cellProps} />;
};
